// extracted by mini-css-extract-plugin
module.exports = {"c17qyko5":"c17qyko5"};